import React from 'react'

import Api from "../../../gd/api/api"
import ProjectSession from "../../../model2/project/project-session"
import {ProjectSystemType} from "../../../model2/project/types";

type Props = {
    projectId       : ID,

    onBeforeDelete  : callback
}

type State = {
    data        : any,
    isDeleting  : boolean
}

export default class ModalDeleteProject extends React.Component<Props, State> {

    constructor(props:Props) {
        super(props);

        this.state = {
            data        : null,
            isDeleting  : false
        }

        const dataLoader = Api.Project.getInfo(this.props.projectId)
        dataLoader.done(response=>{
            this.setState({
                data: response
            })
        })
    }

    onClickDelete = () => {
        this.setState({
            isDeleting: true
        }, async () => {
            if (this.props.onBeforeDelete) this.props.onBeforeDelete()

            const project: ProjectSession = gd.session.projects.get(this.props.projectId)!

            await gd.api.Project.delete(project.id).promise()

            switch (project.systemType) {
                case ProjectSystemType.VIEW:
                    gd.growl.successSticky("View {0} has been deleted.".f(project.name))
                    break

                case ProjectSystemType.WORKSPACE:
                    gd.growl.successSticky("Workspace {0} has been deleted.".f(project.name))
                    break

                default:
                    gd.growl.successSticky("Project {0} has been deleted.".f(project.name))
            }

            gd.modal.hide()
        })
    }

    renderItem(icon:string, title:string, counter:number|null) {
        if (!counter) return null;

        return (
            <div className="item">
                <div className="left">
                    <div className={Classes("ui5-ico-12", icon)}/>
                    <div className="name-txt ui5-txt-default-small">{title}</div>
                </div>
                <div className="right">
                    <div className="counter">{counter ? counter : 0}</div>
                </div>
            </div>
        )
    }

    renderSummaryList() {
        // if (this.state.data) console.log("ModalDeleteProject renderSummaryList", this.state.data.counters);

        const folders = this.state.data ? this.state.data.counters.subfolders : null;
        const tasks = this.state.data ? this.state.data.counters.tasksOpen + this.state.data.counters.tasksClosed : null;
        const events = this.state.data ? this.state.data.counters.events : null;
        const files = this.state.data ? this.state.data.counters.files : null;
        const notes = this.state.data ? this.state.data.counters.notes : null;
        const meetings = _.get(this.state, 'data.counters.meetings', null)

        return (
            <div className="ui5-summary-list">
                {this.renderItem("i5-folder-open", "Subfolders", folders)}
                {this.renderItem("i5-task", "Tasks", tasks)}
                {this.renderItem("i5-event-project-event", "Events", events)}
                {this.renderItem("i5-meeting", "Meetings", meetings)}
                {this.renderItem("i5-file-text", "Notes", notes)}
                {this.renderItem("i5-attachment", "files", files)}
            </div>
        )
    }

    render() {

        let button;
        if (this.state.isDeleting) {
            button = (
                <div className={Classes("gd-btn", {disabled: true, red: true})}>
                    <img key="image" src={gdConfig.assetsPath + "/skin/common/loader/btn-submit-busy.gif"}/>
                </div>
            )
        } else {
            button = (
                <div className={Classes("gd-btn", {disabled: !this.state.data, red: this.state.data})}
                     onClick={this.state.data ? this.onClickDelete : undefined}>
                    Delete
                </div>
            )
        }

        const project : ProjectSession = gd.session.projects.get(this.props.projectId)!

        const showProjectMessage = !project.isView && !project.isWorkspace

        return (
            <div className="gd-form-modal-new">
                <img width="250" src="/app/web/skin/common/illustrations/delete-project.png" />

                {showProjectMessage &&
                    <div className="project-info ui5-txt-default">
                        <p>If you delete the project <b>all related data </b> will be deleted as well.</p>

                        <p>If you want to <b>Archive / Close project</b> - update project status.</p>
                    </div>
                }

                {project.isView &&
                    <div className="project-info ui5-txt-default">
                        <p>Are you sure that you want to delete this view?</p>
                    </div>
                }

                {project.isWorkspace &&
                    <div className="project-info ui5-txt-default">
                        <p>If you delete the <b>workspace</b>, all related data will be deleted as well.</p>

                        <p>f you want to archive it, click the <b>Archive</b> button in <b>Workspace Info</b>.</p>
                    </div>
                }

                {this.renderSummaryList()}

                <div className="actions">
                    {button}
                </div>
            </div>
        )
    }
}